import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import {
  BiCog,
  BiFileBlank,
  BiHomeAlt2,
  BiLeftArrowAlt,
  BiMessage,
} from 'react-icons/bi';
import {
  GoBell,
  GoCalendar,
  GoGraph,
  GoHistory,
  GoPlusCircle,
} from 'react-icons/go';
import { useDocContext } from '../../context/DocContext';
import { clearNotifications } from '../../DB/DB';
const Sidebar = ({ setmenuOpen }) => {
  const router = useRouter();
  const { user, notifications } = useDocContext();
  const { setContext } = useDocContext();
  const clearAllNotifications = useCallback(async () => {
    let notificationsList = notifications.map((n) => {
      return {
        method: 'PUT',
        path: `/parse/classes/Notifications/${n.objectId}`,
        body: {
          seen: true,
        },
      };
    });
    const response = await clearNotifications(notificationsList);

    if (response) {
      setContext((context) => {
        return { ...context, hasNotifications: false };
      });
    }
  }, [setContext, notifications]);
  useEffect(() => {
    if (
      router.asPath == '/dashboard/notifications' &&
      notifications?.length > 0
    ) {
      clearAllNotifications();
    }
  }, [router.asPath, clearAllNotifications, notifications?.length]);
  return (
    <div className='d-flex tw-justify-between tw-h-full flex-column  sidebarInside tw-mt-0'>
      <ul className='nav nav-pills flex-column '>
        <Linker
          path={'/dashboard'}
          name='Home'
          icon={<BiHomeAlt2 />}
          setmenuOpen={setmenuOpen}
        />
        <Linker
          path={'/dashboard/history'}
          name='Diagnostic History'
          icon={<BiFileBlank />}
          setmenuOpen={setmenuOpen}
        />
        <Linker
          path={'/dashboard/messageCenter'}
          name='Messages'
          icon={<BiMessage />}
          setmenuOpen={setmenuOpen}
        />
        <Linker
          path={'/dashboard/track-progress'}
          name='Track Progress'
          icon={<GoGraph />}
          setmenuOpen={setmenuOpen}
        />
        <Linker
          path={'/dashboard/subscriptions'}
          name='Subscriptions'
          icon={<GoCalendar />}
        />
        {/* <Linker
          path={'/dashboard/refills'}git 
          name='Prescription Refills'
          icon={<GoHistory />}
          setmenuOpen={setmenuOpen}
        /> */}
        <Linker
          path={'/dashboard/notifications'}
          name='Notifications'
          icon={<GoBell />}
          setmenuOpen={setmenuOpen}
        />

        <Linker
          path={'/services'}
          name='New Diagnosis'
          icon={<GoPlusCircle />}
          setmenuOpen={setmenuOpen}
        />
        <Linker
          path={'/dashboard/user'}
          name='Account'
          icon={<BiCog />}
          setmenuOpen={setmenuOpen}
        />
      </ul>
      <ul className='nav nav-pills flex-column '>
        <Linker
          path={'/'}
          name='Return to Website'
          icon={<BiLeftArrowAlt />}
          setmenuOpen={setmenuOpen}
        />
      </ul>
    </div>
  );
};

export default Sidebar;

const Linker = ({ path, name, icon, setmenuOpen }) => {
  const router = useRouter();
  const { hasNotifications } = useDocContext();

  return (
    <li
      className={`nav-item`}
      style={{ height: '60px', marginBottom: '6px' }}
      onClick={() => setmenuOpen && setmenuOpen(false)}
    >
      <Link legacyBehavior={true} href={path} passHref>
        <button
          className={` ${router.asPath == path ? 'btnActive' : 'btnNormal'}`}
        >
          {icon}
          {name}{' '}
          {hasNotifications && name == 'Notifications' ? (
            <span className='tw-relative'>
              <FontAwesomeIcon
                icon={faCircle}
                color='#BB0A0A'
                className=' tw-w-3 tw-h-3 tw-absolute tw-top-[-14px] tw-left-[-114px]'
              />
            </span>
          ) : null}
        </button>
      </Link>
    </li>
  );
};
let home = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.73673 2.07306C9.47324 1.86812 9.34149 1.76565 9.19601 1.72626C9.06765 1.69151 8.93235 1.69151 8.80399 1.72626C8.65851 1.76565 8.52677 1.86812 8.26327 2.07306L3.17654 6.0294C2.83652 6.29387 2.6665 6.4261 2.54402 6.5917C2.43552 6.73839 2.3547 6.90365 2.30552 7.07935C2.25 7.2777 2.25 7.49308 2.25 7.92385V13.35C2.25 14.1901 2.25 14.6102 2.41349 14.931C2.5573 15.2133 2.78677 15.4427 3.06901 15.5866C3.38988 15.75 3.80992 15.75 4.65 15.75H6.15C6.36002 15.75 6.46503 15.75 6.54525 15.7092C6.61581 15.6732 6.67317 15.6159 6.70913 15.5453C6.75 15.4651 6.75 15.3601 6.75 15.15V10.2C6.75 9.78001 6.75 9.56999 6.83175 9.40956C6.90365 9.26844 7.01839 9.1537 7.15951 9.08179C7.31994 9.00005 7.52996 9.00005 7.95 9.00005H10.05C10.47 9.00005 10.6801 9.00005 10.8405 9.08179C10.9816 9.1537 11.0963 9.26844 11.1683 9.40956C11.25 9.56999 11.25 9.78001 11.25 10.2V15.15C11.25 15.3601 11.25 15.4651 11.2909 15.5453C11.3268 15.6159 11.3842 15.6732 11.4548 15.7092C11.535 15.75 11.64 15.75 11.85 15.75H13.35C14.1901 15.75 14.6101 15.75 14.931 15.5866C15.2132 15.4427 15.4427 15.2133 15.5865 14.931C15.75 14.6102 15.75 14.1901 15.75 13.35V7.92385C15.75 7.49308 15.75 7.2777 15.6945 7.07935C15.6453 6.90365 15.5645 6.73839 15.456 6.5917C15.3335 6.4261 15.1635 6.29387 14.8235 6.02941L9.73673 2.07306Z'
      fill='#00000000'
      fillOpacity='0.3'
      stroke='#41c9a2'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

let profile = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.1596 11.62C12.1296 11.62 12.1096 11.62 12.0796 11.62C12.0296 11.61 11.9596 11.61 11.8996 11.62C8.99957 11.53 6.80957 9.25 6.80957 6.44C6.80957 3.58 9.13957 1.25 11.9996 1.25C14.8596 1.25 17.1896 3.58 17.1896 6.44C17.1796 9.25 14.9796 11.53 12.1896 11.62C12.1796 11.62 12.1696 11.62 12.1596 11.62ZM11.9996 2.75C9.96957 2.75 8.30957 4.41 8.30957 6.44C8.30957 8.44 9.86957 10.05 11.8596 10.12C11.9096 10.11 12.0496 10.11 12.1796 10.12C14.1396 10.03 15.6796 8.42 15.6896 6.44C15.6896 4.41 14.0296 2.75 11.9996 2.75Z'
      fill='white'
    />
    <path
      d='M12.1696 22.55C10.2096 22.55 8.23961 22.05 6.74961 21.05C5.35961 20.13 4.59961 18.87 4.59961 17.5C4.59961 16.13 5.35961 14.86 6.74961 13.93C9.74961 11.94 14.6096 11.94 17.5896 13.93C18.9696 14.85 19.7396 16.11 19.7396 17.48C19.7396 18.85 18.9796 20.12 17.5896 21.05C16.0896 22.05 14.1296 22.55 12.1696 22.55ZM7.57961 15.19C6.61961 15.83 6.09961 16.65 6.09961 17.51C6.09961 18.36 6.62961 19.18 7.57961 19.81C10.0696 21.48 14.2696 21.48 16.7596 19.81C17.7196 19.17 18.2396 18.35 18.2396 17.49C18.2396 16.64 17.7096 15.82 16.7596 15.19C14.2696 13.53 10.0696 13.53 7.57961 15.19Z'
      fill='white'
    />
  </svg>
);
let history = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.0004 22.7504C10.8704 22.7504 9.79039 22.4204 8.98039 21.8104L4.68039 18.6004C3.54039 17.7504 2.65039 15.9804 2.65039 14.5604V7.12043C2.65039 5.58043 3.78039 3.94043 5.23039 3.40043L10.2204 1.53043C11.2104 1.16043 12.7704 1.16043 13.7604 1.53043L18.7604 3.40043C20.2104 3.94043 21.3404 5.58043 21.3404 7.12043V10.5504C21.3404 10.9604 21.0004 11.3004 20.5904 11.3004C20.1804 11.3004 19.8404 10.9604 19.8404 10.5504V7.12043C19.8404 6.21043 19.0904 5.13043 18.2304 4.80043L13.2404 2.93043C12.5804 2.68043 11.4104 2.68043 10.7504 2.93043L5.76039 4.81043C4.90039 5.13043 4.15039 6.21043 4.15039 7.13043V14.5604C4.15039 15.5104 4.82039 16.8404 5.57039 17.4004L9.87039 20.6104C10.4204 21.0204 11.1904 21.2504 11.9904 21.2504C12.4004 21.2504 12.7404 21.5904 12.7404 22.0004C12.7404 22.4104 12.4104 22.7504 12.0004 22.7504Z'
      fill='#41C9A2'
    />
    <path
      d='M16 20.75C13.38 20.75 11.25 18.62 11.25 16C11.25 13.38 13.38 11.25 16 11.25C18.62 11.25 20.75 13.38 20.75 16C20.75 18.62 18.62 20.75 16 20.75ZM16 12.76C14.21 12.76 12.75 14.22 12.75 16.01C12.75 17.8 14.21 19.26 16 19.26C17.79 19.26 19.25 17.8 19.25 16.01C19.25 14.22 17.79 12.76 16 12.76Z'
      fill='#41C9A2'
    />
    <path
      d='M21 22.0002C20.93 22.0002 20.87 21.9902 20.8 21.9802C20.74 21.9702 20.68 21.9502 20.62 21.9202C20.56 21.9002 20.5 21.8702 20.44 21.8302C20.39 21.7902 20.34 21.7502 20.29 21.7102C20.11 21.5202 20 21.2602 20 21.0002C20 20.8702 20.03 20.7402 20.08 20.6202C20.13 20.5002 20.2 20.3902 20.29 20.2902C20.66 19.9202 21.34 19.9202 21.71 20.2902C21.8 20.3902 21.87 20.5002 21.92 20.6202C21.97 20.7402 22 20.8702 22 21.0002C22 21.2602 21.89 21.5202 21.71 21.7102C21.52 21.8902 21.26 22.0002 21 22.0002Z'
      fill='#41C9A2'
    />
  </svg>
);
let appointments = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19 8.75C16.93 8.75 15.25 7.07 15.25 5C15.25 2.93 16.93 1.25 19 1.25C21.07 1.25 22.75 2.93 22.75 5C22.75 7.07 21.07 8.75 19 8.75ZM19 2.75C17.76 2.75 16.75 3.76 16.75 5C16.75 6.24 17.76 7.25 19 7.25C20.24 7.25 21.25 6.24 21.25 5C21.25 3.76 20.24 2.75 19 2.75Z'
      fill='#41C9A2'
    />
    <path
      d='M12 13.75H7C6.59 13.75 6.25 13.41 6.25 13C6.25 12.59 6.59 12.25 7 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75Z'
      fill='#41C9A2'
    />
    <path
      d='M16 17.75H7C6.59 17.75 6.25 17.41 6.25 17C6.25 16.59 6.59 16.25 7 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z'
      fill='#41C9A2'
    />
    <path
      d='M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z'
      fill='#41C9A2'
    />
  </svg>
);
let notificationBell = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 10.5204C11.59 10.5204 11.25 10.1804 11.25 9.77043V6.44043C11.25 6.03043 11.59 5.69043 12 5.69043C12.41 5.69043 12.75 6.03043 12.75 6.44043V9.77043C12.75 10.1904 12.41 10.5204 12 10.5204Z'
      fill='#41C9A2'
    />
    <path
      d='M12.0199 20.3502C9.43987 20.3502 6.86987 19.9402 4.41987 19.1202C3.50987 18.8202 2.81987 18.1702 2.51987 17.3502C2.21987 16.5302 2.31987 15.5902 2.80987 14.7702L4.07987 12.6502C4.35987 12.1802 4.60987 11.3002 4.60987 10.7502V8.65023C4.60987 4.56023 7.92987 1.24023 12.0199 1.24023C16.1099 1.24023 19.4299 4.56023 19.4299 8.65023V10.7502C19.4299 11.2902 19.6799 12.1802 19.9599 12.6502L21.2299 14.7702C21.6999 15.5502 21.7799 16.4802 21.4699 17.3302C21.1599 18.1802 20.4799 18.8302 19.6199 19.1202C17.1699 19.9502 14.5999 20.3502 12.0199 20.3502ZM12.0199 2.75023C8.75987 2.75023 6.10987 5.40023 6.10987 8.66023V10.7602C6.10987 11.5702 5.78987 12.7402 5.36987 13.4302L4.09987 15.5602C3.83987 15.9902 3.77987 16.4502 3.92987 16.8502C4.07987 17.2502 4.41987 17.5502 4.89987 17.7102C9.49987 19.2402 14.5599 19.2402 19.1599 17.7102C19.5899 17.5702 19.9199 17.2502 20.0699 16.8302C20.2299 16.4102 20.1799 15.9502 19.9499 15.5602L18.6799 13.4402C18.2599 12.7502 17.9399 11.5802 17.9399 10.7702V8.67023C17.9299 5.40023 15.2799 2.75023 12.0199 2.75023Z'
      fill='#41C9A2'
    />
    <path
      d='M11.9999 22.9003C10.9299 22.9003 9.87992 22.4603 9.11992 21.7003C8.35992 20.9403 7.91992 19.8903 7.91992 18.8203H9.41992C9.41992 19.5003 9.69992 20.1603 10.1799 20.6403C10.6599 21.1203 11.3199 21.4003 11.9999 21.4003C13.4199 21.4003 14.5799 20.2403 14.5799 18.8203H16.0799C16.0799 21.0703 14.2499 22.9003 11.9999 22.9003Z'
      fill='#41C9A2'
    />
  </svg>
);
let newDiagnosis = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='100'
    height='100'
    viewBox='0 0 50 50'
  >
    <path
      d='M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 24 13 L 24 24 L 13 24 L 13 26 L 24 26 L 24 37 L 26 37 L 26 26 L 37 26 L 37 24 L 26 24 L 26 13 L 24 13 z'
      fill='none'
      stroke='#41c9a2'
      stroke-width='1'
    />
  </svg>
);
